import FlatPickr from '../../../../vendor/FlatPickr';

// Vendor
FlatPickr.initDateRangePicker();
